"use client";

import { c as _c } from "react/compiler-runtime";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { sanitizeListingPrice } from "../../helpers";
export const TraitFloorButton = () => {
  const $ = _c(10);
  const t = useTranslations("wallet.TraitFloorButton");
  const {
    control,
    setValue
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "listings"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const listings = useWatch(t0);
  let t1;
  if ($[2] !== listings || $[3] !== setValue) {
    t1 = () => {
      listings.forEach((listing, index) => {
        if (listing.traitFloorPrice) {
          setValue(`listings.${index}.price`, sanitizeListingPrice(listing.traitFloorPrice), {
            shouldValidate: true
          });
        }
      });
    };
    $[2] = listings;
    $[3] = setValue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const setToFloor = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("traitFloor");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== setToFloor || $[8] !== t2) {
    t3 = <Button onClick={setToFloor} size="sm" variant="secondary">{t2}</Button>;
    $[7] = setToFloor;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};